<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div v-if="title" class="card-header">
        <h4 class="card-title">{{title}}</h4>
        <p v-if="description" class="category">{{description}}</p>
      </div>
      <div class="card-content">
        <div class="form-group">
          <label v-if="message">
            {{message}}
          </label>
          <input class="form-control border-input" v-model="value" :maxlength="maxChars"  @keyup.enter="loading = true; action(value)" @keydown.space.prevent />
          <span class="help-block">{{charsLeft}} character(s) left.</span>
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="$modal.close()" class="btn">{{closeText}}</button>
          <base64-uploader @data="upload" :disabled="!value" class="pull-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Base64Uploader from 'src/components/Inputs/Base64Uploader'

  export default {
    name: 'modal-message',
    components: {
      Base64Uploader
    },
    data () {
      return {
        loading: false,
        value: null
      }
    },
    props: {
      title: String,
      description: String,
      message: String,
      maxChars: {type: Number, default: 30},
      closeText: {type: String, default: "Close"},
      action: {type: Function}
    },
    computed: {
      charsLeft() {
        return this.maxChars - (this.value != null ? this.value.length : 0)
      }
    },
    methods: {
      upload (filename, base64Data) {
        this.loading = true
        this.action(this.value, filename, base64Data)
      }
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>